<template>
  <div class="main-content telephonyAccess">
    <div class="card" v-if="users">
      <div class="card-header">
        <h5>Менеджеры</h5>
        <p>управление доступами к номерам телефонов с которых возможно совершать исходящие звонки</p>
      </div>
      <div class="card-body">
        <div class="flex flex-wrap users_radio_block">
          <div v-for="user in users" v-if="user.is_active" :key="user.id">
            <input type="radio" v-model="selectedUser" class="btn-check hidden" name="selected_user"
                   :id="`u_${user.id}`"
                   autocomplete="off" :value="user">
            <label class="btn btn-primary" :for="`u_${user.id}`">{{ user.name }} ({{ user.id }}) -
              [{{ getActivePhonesByUser(user) }}]</label>
          </div>
        </div>

        <hr>
        <h5>Смены</h5>
        <!--        <p>управление доступами к номерам телефонов в зависимости от группы</p>-->
        <div class="flex flex-wrap users_radio_block">
          <!--          <div v-for="g in groups" v-if="g.is_active" :key="`group_${g.id}`">-->
          <div v-for="g in shifts" v-if="g.is_active" :key="`group_${g.id}`">
            <input type="radio" v-model="selectedGroup" class="btn-check hidden" name="selected_shift" :id="g.id"
                   autocomplete="off" :value="g">
            <label class="btn btn-primary" :for="g.id">{{ g.title }} ({{ g.id }})</label>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <form @submit.prevent="search()">
        <div class="card-body flex search_blocks">
          <div class="form-group">
            <label for="">Номер</label>
            <input type="text" placeholder="Номер телефона" v-model="searchData.phone" class="form-control">
          </div>
          <div class="flex btns">
            <button type="button" @click="search(true)" class="btn btn-default align-self-end">Сбросить</button>
          </div>
          <div class="flex btns">
            <button type="submit" class="btn btn-info align-self-end">Поиск</button>
          </div>
        </div>
      </form>
    </div>

    <div class="card" v-if="searchResult">
      <div class="card-body">
        <template v-if="!searchRecords || (searchRecords && !searchRecords.length)">
          <p>Не надены телефоны</p>
        </template>
        <template v-else>
          <table class="table-hover table table-sm">
            <tbody>
            <tr v-for="(record, index) in searchRecords">
              <td>{{ index + 1 }}</td>
              <td>{{ record.display_phone }}</td>
              <td>{{ record.description }}</td>
              <td>
                <p v-if="$AllProjects && $AllProjects[record.site_id]">{{ $AllProjects[record.site_id].name }} -
                  {{ $AllProjects[record.site_id].title }}</p>
                <p v-if="$AllCities && $AllCities[record.city_id]">{{ $AllCities[record.city_id].short_name }} -
                  {{ $AllCities[record.city_id].name }}</p>
              </td>
              <td>
                <p @click="showUser(user, record.id)" class="pointer btn-link"
                   v-for="(user) in getUsersByPhone(record.phone)">{{ user.name }}</p>
              </td>
            </tr>
            </tbody>
          </table>
        </template>
      </div>
    </div>

    <div class="card" v-if="(selectedUser || selectedGroup) && !searchResult">
      <div class="card-header">
        <h5>{{ selectedUser && selectedUser.name || selectedGroup && selectedGroup.title }}
          <span class="pull-right">
            <vue-ladda button-class="btn btn-sm btn-success"
                       data-style="zoom-in"
                       @click="updateUser"
                       :loading="saveLoading">Сохранить
              </vue-ladda>
        </span>
        </h5>
      </div>
      <div class="card-body">
        <div v-if="phones">
          <table class="table table-sm table-hover">
            <thead>
            <tr>
              <th></th>
              <th></th>
              <th></th>
              <th class="text-right">
                <button @click="updateFilter(true)" class="btn btn-default mb-3">Сбросить</button>
              </th>
              <th>
                <div class="form-group">
                  <label for="">Проект</label>
                  <select @change="updateFilter(false)" class="form-control" v-model="filter.site_id">
                    <option value="0">Все проекты</option>
                    <option v-for="project in $AllProjects" v-if="project.id && project.is_active" :value="project.id">
                      {{
                        project.name
                      }}
                    </option>
                  </select>
                </div>
              </th>
              <th>
                <div class="form-group">
                  <label for="">Город</label>
                  <select @change="updateFilter(false)" class="form-control" v-model="filter.city_id">
                    <option value="0">Любой город</option>
                    <option v-for="city in sortArray(Object.values($AllCities), 'name')" :value="city.id">
                      {{ city.name }}
                    </option>
                  </select>
                </div>
              </th>
            </tr>
            <tr>
              <th></th>
              <th>
                <input type="checkbox" name="" @change="updateSelectedPhones">
              </th>
              <th>Телефон</th>
              <th>Описание</th>
              <th>Сайт</th>
              <th>Город</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(phone, index) in phones" :key="phone.id" v-bind:class="{'selected': phone.searchSelected}">
              <td>{{ index + 1 }}</td>
              <td>
                <input type="checkbox" v-model="selectedPhones[phone.id]">
              </td>
              <td>{{ phone.display_phone }}</td>
              <td>{{ phone.description }}</td>
              <td><span v-if="$AllProjects && $AllProjects[phone.site_id]">{{
                  $AllProjects[phone.site_id].name
                }} - {{ $AllProjects[phone.site_id].title }}</span></td>
              <td><span v-if="$AllCities && $AllCities[phone.city_id]">{{
                  $AllCities[phone.city_id].short_name
                }} - {{ $AllCities[phone.city_id].name }}</span></td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import api from '@/api'
import VueLadda from 'vue-ladda/src/vue-ladda.vue'

export default {
  components: {
    VueLadda,
  },
  data() {
    return {
      loading: false,
      saveLoading: false,
      loadingColor: this.$constants.LOADING_COLOR,
      users: null,
      shifts: null,
      AllPhones: null,
      phones: null,
      selectedUser: null,
      selectedShift: null,
      selectedGroup: null,
      selectedPhones: {},
      searchData: {},
      groups: [],
      filter: {},
      searchResult: false,
      searchRecords: null,
    }
  },
  computed: {
    $AllProjects() {
      return this.$store.getters['platform/projects'].reduce((acc, p) => {
        acc[p.id] = p
        return acc;
      }, {});
    },
    $AllCities() {
      return this.$store.getters['platform/cities'];
    },
  },
  async mounted() {
    await this.getManagers();
  },
  watch: {
    selectedUser: function () {
      // console.log('select user');
      if (this.selectedUser === null) return;
      this.selectedShift = null;
      this.selectedPhones = {};
      this.selectedUser.phones.forEach((p) => {
        this.selectedPhones[p.phone_id] = true;
      })
      this.updateFilter();
      this.searchResult = false;
    },
    selectedGroup: function () {
      // console.log('select group');
      if (this.selectedGroup === null) return;
      this.selectedUser = null;
      this.selectedPhones = {};
      // if (!this.selectedGroup.phones) this.selectedGroup.phones = [];
      this.selectedGroup.phones.forEach((p) => {
        this.selectedPhones[p.phone_id] = true;
      })
      this.updateFilter();
      this.searchResult = false;
    }
  },
  methods: {
    getActivePhonesByUser(user) {
      return (this.phones ?? []).reduce((acc, p) => {
        if ((user.phones ?? []).find((up) => up.phone_id === p.id)) ++acc;
        return acc;
      }, 0)
    },
    updateSelectedPhones(prop) {
      const status = prop.target.checked;
      const selectedPhones = {...this.selectedPhones};
      this.phones.forEach((p) => {
        selectedPhones[p.id] = status;
      })
      this.selectedPhones = selectedPhones;
    },
    async updateUser() {
      this.saveLoading = true;
      let {data} = await api.post('/telephony/managers', {
        user: this.selectedUser ? {id: this.selectedUser.id} : null,
        // shift: this.selectedShift ? {id: this.selectedShift.id} : null,
        shift: this.selectedGroup ? {id: this.selectedGroup.id} : null,
        // group: this.selectedGroup ? {id: this.selectedGroup.id} : null,
        phones: this.selectedPhones
      });
      if (!data.success) {
        this.Toast.fire({
          type: 'warning',
          title: data.message || 'Ошибка'
        })
        return;
      }
      await this.getManagers();
      this.Toast.fire({
        type: 'success',
        title: data.message || 'Сохранено'
      })
      this.saveLoading = false;
    },
    showUser(user, phoneId = null) {
      this.selectedUser = user;
    },
    getUsersByPhone(phone) {
      return this.users.filter((u) => u.phones && u.phones.length && u.phones.find((p) => p.phone && p.phone.includes(phone)));
    },
    updateFilter(reset = false) {
      let list = [...this.AllPhones];
      if (reset) {
        this.filter = {};
        this.phones = list;
        return;
      }
      if (this.filter.site_id && this.filter.site_id !== '0') {
        list = list.filter((p) => p.site_id == this.filter.site_id);
      }
      if (this.filter.city_id && this.filter.city_id !== '0') {
        list = list.filter((p) => p.city_id == this.filter.city_id);
      }
      this.phones = list;
    },
    async search(reset = false) {
      if (reset) {
        this.AllPhones.forEach((p) => p.searchSelected = false)
        this.searchData = {};
        this.searchResult = false;
        return;
      }
      this.searchRecords = null;
      if (this.searchData.phone) {
        const phone = this.searchData.phone.replace(/\D/g, "");
        this.searchRecords = this.AllPhones.filter((p) => p.phone.includes(phone));
        this.AllPhones.forEach((p) => {
          if (p.phone.includes(phone)) {
            p.searchSelected = true;
          }
        })
      }
      this.searchResult = true;
    },
    async getManagers() {
      let {data} = await api.index('/telephony/managers');
      if (!data.success) {
        this.Toast.fire({
          type: 'warning',
          title: data.message || 'Ошибка'
        })
        return;
      }
      this.groups = data.groups;
      this.users = data.users;
      this.shifts = data.shifts;
      this.AllPhones = data.phones;

    }
  }
}

</script>

<style scoped>
.search_blocks .form-group {
  margin: 0;
  margin-right: 5px;
}

.users_radio_block div {
  margin-right: 5px;
}

.b-0 {
  bottom: 1rem;
}

.search_blocks div {
  margin-right: 10px;
}

.table p {
  margin-bottom: 2px;
}

.table tr.selected {
  background-color: #dbdbff;
}
</style>
